import Nav from "./nav"
// import Animation from "./animation"

document.addEventListener("DOMContentLoaded", function () {
    Nav(jQuery)
    // Animation(jQuery)
})
